import type { Theme } from '@mui/material';

export const styles = {
  actionButton: (theme: Theme) => ({
    '& .MuiButton-endIcon, & .MuiButton-startIcon': {
      // Center button icons on smallest mobile viewport, when text ist not rendered.
      [theme.breakpoints.down('sm')]: {
        margin: 0,
      },
    },
  }),
};
